module.exports = __webpack_public_path__ + "img/pic_8.4425a2f8.jpg";